import React from 'react';
import PageHeading from '../../shared/pageHeading/PageHeading';
import TableSelector from '../../shared/tableSelector/TableSelector';

const Profile = () => {
	return (
		<div className='Container'>
			<PageHeading heading={'Profil'} />
			<section className='AddCustomer'>
				<div>
					<label>Förnamn</label>
					<input placeholder='Förnamn' />
				</div>
				<div>
					<label>Efternamn</label>
					<input placeholder='Efternamn' />
				</div>
				<div>
					<label>Telefon nummer</label>
					<input placeholder='Telefon nummer' />
				</div>
			</section>
			<TableSelector />
		</div>
	);
};

export default Profile;
